// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SavedItemModalController {
   $controller: any
   $scope: any
   alerts: any
   cloudStorage: any
   events: any
   i18n: any
   savedSearch: any
   constructor($controller: any, $scope: any, cloudStorage: any, savedSearch: any, events: any, i18n: any, alerts: any) {
      // set title and current search for Saved Items modal
      this.$controller = $controller
      this.$scope = $scope
      this.cloudStorage = cloudStorage
      this.savedSearch = savedSearch
      this.events = events
      this.i18n = i18n
      this.alerts = alerts

      // instantiate base controller functionality on scope
      this.$controller('SavedSearchAndItemsBaseCtrl', {$scope: this.$scope, cloudStorage: this.cloudStorage, savedSearch: this.savedSearch, events: this.events, i18n: this.i18n, alerts: this.alerts})
   }
}

SavedItemModalController.$inject = ['$controller', '$scope', 'cloudStorageService', 'savedSearchService', 'eventService', 'translationService', 'alertService']

angular.module('summonApp.controllers')
   .controller('SavedItemModalCtrl', SavedItemModalController)
